import React from "react";
import useCount from "./useCount/useCount";
import Icon from "../../Icon/Icon";
import Text from "../../Text/Text";
import "./index.css";
const CounterWidget = ({ widgetInformation, onWidgetEdit }) => {
  const { config = {} } = widgetInformation || {};
  const { identifier, icon } = config || {};
  const { count, loading, error, initialize } = useCount(config);
  return (
    <div onClick={onWidgetEdit} className="lead360CounterWrapper">
      <div className="lead360CounterContent">
        {!error && (
          <Text
            text={loading ? "..." : count}
            className="ng_h_5_b"
            color="rgb(var(--ng-neutral-90))"
          />
        )}
        {error && (
          <span className="retryButton" onClick={initialize}>
            retry
          </span>
        )}
        <Text text={identifier} className="ng_p_1_sb" color="rgb(var(--ng-neutral-60))" />
      </div>
      <Icon
        src={`images/${icon?.imgName}.svg`}
        alt={identifier}
        width="32px"
        height="32px"
      />
    </div>
  );
};

export default CounterWidget;
